// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QDHxx","heading":"styles_heading__0CYZW","subheading":"styles_subheading__j4wnK","button":"styles_button__pBHsK"};